import * as Sentry from '@sentry/vue';

export default {
  setUserInfo: (data) => {
    if (data.userId && data.username) {
      Sentry.setUser({
        id: data.userId,
        username: data.username,
      });
    }
  },
  unsetUserInfo: () => {
    Sentry.setUser(null);
  },
  addBreadcrumb: (category, message, level = 'info', data = {}) => {
    Sentry.addBreadcrumb({
      category,
      message,
      level,
      data,
    });
  },
  captureException: (error, { tags = {}, extra = {} } = {}) => {
    Sentry.captureException(error, {
      tags,
      extra,
    });
  },
};
